import { render, staticRenderFns } from "./VideoRender.vue?vue&type=template&id=69163f27&"
import script from "./VideoRender.vue?vue&type=script&lang=js&"
export * from "./VideoRender.vue?vue&type=script&lang=js&"
import style0 from "./VideoRender.vue?vue&type=style&index=0&id=69163f27&prod&module=true&lang=css&"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports